import React, { useCallback } from "react";
import { getLabelFromUserAccountRole } from "../../../../../domain/user/account/UserAccountRole";
import { useCareCommentAnalysisDataList } from "../../../../hooks/admin/care_comment_analysis/useCareCommentAnalysisDataList";
import { SaveButton } from "../../../common/button/SaveButton";
import { CareCommentAnalysisDataFilter } from "./CareCommentAnalysisDataFilter";

export const CareCommentAnalysisDataMenu = React.memo(function CareCommentAnalysisDataMenu() {
    const { list } = useCareCommentAnalysisDataList();

    const saveCsv = useCallback(() => {
        const commaJoinedList = list.flatMap((analysisData, index) => {
            const careCommentData = `${index + 1},${analysisData.createdTime.format()},${analysisData.houseId.value},${analysisData.title.value},${analysisData.registerCount}`;
            
            if (!analysisData.userDataList.length) return careCommentData;

            return analysisData.userDataList.map(userData => (
                `${careCommentData},${userData.userName.value},${userData.email.value},${getLabelFromUserAccountRole(userData.role)},${userData.readTime ? userData.readTime.format() : ""}`
            ));
        });

        const indentionJoinedList = commaJoinedList.join("\n");

        const csv = new Blob([indentionJoinedList], { type: "text/csv" });

        const downloadLink = document.createElement("a");

        downloadLink.style.visibility = "hidden";

        downloadLink.href = URL.createObjectURL(csv);

        downloadLink.download = "ケアコメント開封ログ.csv";

        // Firefox では body の中にダウンロードリンクがないといけないので一時的に追加
        document.body.appendChild(downloadLink);

        downloadLink.click();

        // Firefox 対策で追加したリンクを削除しておく
        document.body.removeChild(downloadLink);
    }, [list]);

    return (
        <div className={"table_menu"}>
            {/* csv保存 */}
            <SaveButton onClick={saveCsv} />
            {/* 日付のフィルター */}
            <CareCommentAnalysisDataFilter />
        </div>

    );
});
